module.exports = __webpack_public_path__ + "static/get_your_own_custom_template-6233a55c031211fafefd6148f100b1c0.png";